import React, { useContext, useEffect, useState } from "react";
import styles from "./Auth.module.css";
import "./TranslateAuth.css";
import Logo from "./../../assets/logo.png";
import Calculator from "./Calculator/Calculator";
import Admin from "./Admin/Admin";
import TranslateComponent from "../../components/common/TranslateComponent";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constants/Routes";

const Auth = () => {
  const [activeTab, setActiveTab] = useState("tab1");
  const navigate = useNavigate();
  const activeTabHandler = (tab) => {
    setActiveTab(tab);
  };

  // const { getAuthToken, authUserType } = useContext(AuthContext);

  // useEffect(() => {
  //   const authToken = getAuthToken();
  //   if (authToken === "null" || authToken === null) {
  //     navigate(ROUTES.AUTH);
  //   } else {
  //     if (authUserType == "admin") {
  //       navigate(ROUTES.ADMIN_HOME);
  //     } else if (authUserType == "cal_user") {
  //       navigate(ROUTES.CAL_LIST);
  //     }
  //   }
  // }, [getAuthToken]);

  return (
    <div className="grid w-full grid-cols-1 lg:grid-cols-[671px_minmax(100px,1fr)]  h-screen relative">
      {/* Translate Component */}
      <div className="absolute top-4 right-4 z-10 auth-translate">
        <TranslateComponent />
      </div>

      <div className="grid content-center p-4 pb-10 lg:content-center md:p-4 bg-secondary-color">
        <div className="">
          <div className="grid items-end mt">
            <div className="max-w-[34.5rem]  w-full bg-white mx-auto rounded-xl">
              {/* Header */}
              <div className="flex flex-row w-full">
                <div
                  className={`flex items-center justify-center transition-all ease-in-out duration-75 rounded-tl-xl cursor-pointer w-1/2  px-5 py-2 text-center bg-[#F2F2F2] border-b-[#CCC] border-r-[1px] border-r-[#CCC] border-b-[1px] border-solid ${
                    activeTab === "tab1" ? styles.active : ""
                  }`}
                  onClick={() => {
                    activeTabHandler("tab1");
                  }}
                >
                  <span className="flex items-center justify-center h-12 text-secondary-color font-source-sans-pro">Kalkulátor</span>
                </div>
                <div
                  className={`flex items-center justify-center transition-all ease-in-out duration-75 rounded-tr-xl cursor-pointer w-1/2 px-5 py-2 text-center bg-[#F2F2F2] border-b-[#CCC] border-l-[1px] border-l-[#CCC] border-b-[1px] border-solid ${
                    activeTab === "tab2" ? styles.active : ""
                  }`}
                  onClick={() => {
                    activeTabHandler("tab2");
                  }}
                >
                  <span className="flex items-center justify-center h-12 text-secondary-color font-source-sans-pro">Admin felület</span>
                </div>
              </div>

              {/* Card Body */}
              <div className={`flex flex-col w-full p-[1.875rem]   ${activeTab === "tab1" ? "block" : "hidden"}`}>
                <Calculator />
              </div>

              <div className={`flex flex-col w-full p-[1.875rem]  ${activeTab === "tab2" ? "block" : "hidden"}`}>
                <Admin />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`hidden lg:block h-full  ${styles.loginSideImage}`}></div>
    </div>
  );
};

export default Auth;
